$('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const offsetTop = $('#product-main').offset().top - 160;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 600);
  });

  $('.AddToCart').on('click', function (e) {
    e.preventDefault();
    const variantId = $(this).data('id');
    $.post('/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, function (response) {
      log.collapse(response, 'Added to Cart', 'success');
      theme.ajaxCart.update();
    }).fail(function (response) {
      log.collapse(response, 'Add to Cart Failed', 'error');
    });
  });